import React from "react";

const Heading = ({ text }) => {
  return <h1 className="font-bold font-poet tracking-widest text-red-600 text-xl uppercase">{text}</h1>;
};

export default Heading;
